module.exports = __webpack_public_path__ + "img/lanhe.9c1cbfd0.jpeg";